module.exports = __webpack_public_path__ + "assets/7d41895f21baf00cb21bcf3f7ddea52f.png";